import React, { FC, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormInputOtp } from '../../../../inputs/FormInputOtp';
import { CustomMUIButton } from '../../../../commons/buttons/CustomMUIButton';
import { TextButton } from '../../../../commons/buttons/TextButton';
import { ButtonClassNames } from '../../../../../models/Common';

interface ConfirmationBySmsCodeFormProps {
  handleBack: () => void;
  handleCodeSubmit: ({ smsCode }: { smsCode: string }) => void;
  handleResendCode: (phone: string) => void;
  textElement: JSX.Element;
  phoneNumber: string;
  timer: number;
}

interface CredentialWithCode extends Credential {
  code?: string;
}

export const ConfirmationBySmsCodeForm: FC<ConfirmationBySmsCodeFormProps> = ({
  handleBack,
  handleCodeSubmit,
  textElement,
  handleResendCode,
  phoneNumber,
  timer,
}) => {
  const { t } = useTranslation();
  const methods = useForm();
  const {
    handleSubmit,
    setValue,
    formState: { errors },
  } = methods;

  useEffect(() => {
    if ('OTPCredential' in window) {
      const ac = new AbortController();
      const options = { otp: { transport: ['sms'] }, signal: ac.signal };
      navigator.credentials
        .get(options)
        .then((otp: CredentialWithCode | null) => {
          setValue('smsCode', otp?.code);
          ac.abort();
        })
        .catch(() => {
          ac.abort();
        });
    }
  }, []);

  return (
    <FormProvider {...methods}>
      {textElement}
      <form className="confirmation-email-form" onSubmit={handleSubmit(handleCodeSubmit)}>
        <FormInputOtp
          name="smsCode"
          inputClassName="primary"
          containerClassName="confirmation-email-form__otp"
          isRequired
          minMaxLength={4}
        />
        {errors.smsCode?.message && (
          <p className="login-enter-code-sms-container__form__error">{errors.smsCode?.message}</p>
        )}
        <div className="confirmation-email-form__btn-group">
          <CustomMUIButton
            label={t('common.back')}
            handleClick={handleBack}
            className={ButtonClassNames.SecondaryOutlined}
          />
          <CustomMUIButton type="submit" label={t('buttons.continue')} className={ButtonClassNames.PrimaryFulfilled} />
        </div>

        <TextButton
          label={timer > 0 ? `${t('auth.sendCodeAgain')} (${timer})` : t('auth.sendCodeAgain')}
          handleClick={() => handleResendCode(phoneNumber)}
          className="primary"
          isArrow={false}
          isDisabled={timer !== 0}
        />
      </form>
    </FormProvider>
  );
};
